
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.333 15.833a.833.833 0 11-1.666 0c0-1.378-1.122-2.5-2.5-2.5-.57 0-1.11.195-1.547.541a5.81 5.81 0 01.713 2.793.833.833 0 11-1.666 0A4.171 4.171 0 007.5 12.5a4.171 4.171 0 00-4.167 4.167.833.833 0 11-1.666 0A5.84 5.84 0 017.5 10.833c1.606 0 3.06.653 4.117 1.705a4.161 4.161 0 012.55-.871 4.171 4.171 0 014.166 4.166zM14.167 7.5a.834.834 0 11-.002 1.668.834.834 0 01.002-1.668zm0 3.333c1.378 0 2.5-1.121 2.5-2.5 0-1.378-1.122-2.5-2.5-2.5a2.503 2.503 0 00-2.5 2.5c0 1.379 1.121 2.5 2.5 2.5zM7.5 4.167c.92 0 1.667.747 1.667 1.666 0 .92-.748 1.667-1.667 1.667-.92 0-1.667-.747-1.667-1.667 0-.919.748-1.666 1.667-1.666zm0 5a3.337 3.337 0 003.333-3.334A3.337 3.337 0 007.5 2.5a3.337 3.337 0 00-3.333 3.333A3.337 3.337 0 007.5 9.167z"}})])
          )
        }
      }
    